<template>
    <b-sidebar
      id="add-new-user-sidebar"
      :visible="isAddNewUserSidebarActive"
      bg-variant="white"
      sidebar-class="sidebar-lg"
      shadow
      backdrop
      no-header
      right
      @change="(val) => $emit('update:is-add-new-user-sidebar-active', val)"
    >
      <template #default="{ hide }">
        <!-- Header -->
        <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
          <h5 class="mb-0">
            {{ userLocal.id ? 'Update': 'Add' }} Appointment
          </h5>
  
          <feather-icon
            class="ml-1 cursor-pointer"
            icon="XIcon"
            size="16"
            @click="hide"
          />
  
        </div>
  
        <!-- BODY -->
        <validation-observer
          #default="{ handleSubmit }"
          ref="refFormObserver"
        >
          <!-- Form -->
          <b-form
            class="p-2"
            @submit.prevent="handleSubmit(onSubmit)"
            @reset.prevent="resetForm"
          >
  
            <!-- Appointment -->
            <validation-provider
              #default="validationContext"
              name="Appointment"
              rules="required"
            >
              <b-form-group
                label="Appointment"
                label-for="appointment"
              >
                <b-form-input
                  id="appointment"
                  v-model="userLocal.appointment"
                  autofocus
                  :state="getValidationState(validationContext)"
                  trim
                  placeholder="New Appointment"
                />
  
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>


             <!-- Description -->
             <b-form-group
                label="Description"
                label-for="description"
              >
                <b-form-textarea
                  id="description"
                  v-model="userLocal.description"
                  trim
                  placeholder="Description"
                >
                </b-form-textarea>
            </b-form-group>
            
            <!-- Members -->
            <b-form-group
                label="Add Members"
                label-for="members"
              >
                <v-select
                  v-model="userLocal.members"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="getAllMembers.map(p=>({ member: p.fullName, memID: p.memID, contact1: p.contact1 }))"
                  label="member"
                  multiple
                  :close-on-select="false"
                  input-id="members"
                />
                <template #option="{ memID, member }">
                  <!-- <b-avatar
                    size="sm"
                    :src="avatar"
                  /> -->
                  <span> {{ memID }}</span>
                  <span class="ml-50 align-middle"> {{ member }}</span>
                </template>

                <template #selected-option="{  member }">
                  <!-- <b-avatar
                    size="sm"
                    class="border border-white"
                    :src="avatar"
                  /> -->
                  <span class="ml-50 align-middle"> {{ member }}</span>
                </template>
            </b-form-group>

            <!-- from -->
            <b-form-group
                label="From"
                label-for="from"
              >
                  <b-form-datepicker
                        v-model="userLocal.from"
                        class="form-control"
                        placeholder="YYYY-MM-DD"
                        type="date"
                    />    
            </b-form-group>

            <b-form-group
                label="To"
                label-for="To"
              >
                  <b-form-datepicker
                        v-model="userLocal.to"
                        class="form-control"
                        placeholder="YYYY-MM-DD"
                        type="date"
                    />    
            </b-form-group>
  
            <!-- Form Actions -->
            <div class="d-flex mt-2">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="mr-2"
                type="submit"
              >
                Submit
              </b-button>
              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                type="button"
                variant="outline-secondary"
                @click="hide"
              >
                Cancel
              </b-button>
            </div>
  
          </b-form>
        </validation-observer>
      </template>
    </b-sidebar>
  </template>
  
  <script>
  import {
    BSidebar, BForm, BFormGroup, BFormInput, BFormTextarea, BFormInvalidFeedback, BButton, BFormDatepicker
  } from 'bootstrap-vue'
  import { ValidationProvider, ValidationObserver } from 'vee-validate'
  import { ref,toRefs } from '@vue/composition-api'
  import { required, alphaNum, email } from '@validations'
  import formValidation from '@core/comp-functions/forms/form-validation'
  import Ripple from 'vue-ripple-directive'
  import vSelect from 'vue-select'
  import countries from '@/@fake-db/data/other/countries'
  import useMembersList from '../../membership/members-list/useMemberList'
  import useAppointmentsListAddNew from './useAppointmentListAddNew'
  
  export default {
    components: {
      BSidebar,
      BForm,
      BFormGroup,
      BFormInput,
      BFormTextarea,
      BFormInvalidFeedback,
      BButton,
      vSelect,
      BFormDatepicker,

      // Form Validation
      ValidationProvider,
      ValidationObserver,
    },
    directives: {
      Ripple,
    },
    model: {
      prop: 'isAddNewUserSidebarActive',
      event: 'update:is-add-new-user-sidebar-active',
    },
    props: {
      isAddNewUserSidebarActive: {
        type: Boolean,
        required: true,
      },
      userData: {
        type: Object
      },
      clearUserData: {
        type: Function,
        required: true,
      },
    },
    data() {
      return {
        required,
        alphaNum,
        email,
        countries,
      }
    },
    setup(props, { emit }) {

      
      const clearFormData = ref(null)
      

      const { 
        userLocal,
        resetUserLocal,
        onSubmit, 
      
      } = useAppointmentsListAddNew(toRefs(props), clearFormData, emit)

      const { getAllMembers } = useMembersList()
  
      const {
        refFormObserver,
        getValidationState,
        resetForm,
        clearForm,
      } = formValidation(resetUserLocal, props.clearUserData)

      clearFormData.value = clearForm
  
      return {
        userLocal,
        onSubmit,
        
        resetForm,
        refFormObserver,
        getValidationState,
        getAllMembers
      }
    },
  }
  </script>
  
  <style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
  
  #add-new-user-sidebar {
    .vs__dropdown-menu {
      max-height: 200px !important;
    }
  }
  </style>
  